import flagKeys from '@/constants/flagKeys';
import { Route } from '../route.model';

import OffersActivities from '@/views/Transactions/OffersActivities.vue';

const discountsActivities = new Route(
  '/transactions/offers',
  'transaction_all_transactions',
  OffersActivities,
  {
    requiresAuth: true,
    flag: flagKeys.legacyReports,
    requiresCountry: ['United States'],
    isResponsive: flagKeys.responsiveDashboard,
    zendesk: {
      mobile: {
        offsetHorizontal: '4px',
        offsetVertical: '4px'
      }
    },
    navbar: {
      name: 'Discounts Activities', // TODO apply i18n
      icon: 'conversions'
    }
  }
);

export { discountsActivities };
export default discountsActivities;
